import $ from 'jquery';
const channelPlaylistView = require('templates/channel_playlist.jst.jade')

export default class ChannelPlaylist {
  constructor({ $element: $element }) {
    this.$element = $element;
    this.state = {videos: []};
    this.state.locale = $('meta[name="language"]').attr("content");
    this.state.collection_id = this.$element.data('collection-id');
    this.state.video_id = this.$element.data('video-id');
    this.list = 'li.clearfix[data-video-id="'+this.state.video_id+'"]';
    this.collectionSize = 20;
    this.collectionPage = 1;
    this.endOfList = false;
    this.lastRequestedPage = 0;
  }

  init() {
    this.request();
    this.bindElementScroll();
  }

  getUrl() {
    return '/channels/' + this.state.collection_id + '/playlist.json';
  }

  request() {
    if (this.lastRequestedPage == this.collectionPage) return;
    this.lastRequestedPage++;
    $.ajax({
      method: 'GET',
      url: `${this.getUrl()}?size=${this.collectionSize}&page=${this.collectionPage}`,
      dataType: 'json'
    }).done((data) => {
      if (data.videos.length < this.collectionSize) this.endOfList = true;
      this.removeContent();
      this.state.videos = data.videos;
      this.render();
      this.collectionPage++;
    });
  }

  removeContent() {
    if (this.collectionPage > 1) return;
    this.$element.empty();
  }

  render() {
    this.$element.append($(channelPlaylistView({ videos: this.state.videos, textPlay: this.textPlayLanguage() })));
    this.addSelected();
  }

  addSelected() {
    $(this.list).addClass('selected');
  }

  textPlayLanguage() {
    if(this.state.locale=='en') {
      return 'Plays';
    } else {
      return 'Diputar';
    }
  }

  bindElementScroll(){
    this.$element[0].addEventListener('scroll', () => {
      if (this.isScrollReachBottom() && !this.endOfList) this.request();
    });
  }

  isScrollReachBottom(){
    let element = this.$element[0];
    return (element.scrollHeight - element.offsetHeight) <= element.scrollTop + 83;
  }
}
